import httpClient from '../../config/accountRecoveryHttp.client'

/** @param {{ url: string, method?: string, headers?: object, data?: any }} options */
export const request = ({ url, method = 'POST', headers = {}, data }) =>
  httpClient.request({ url, method, headers, data })
